export * from './book-me-posting.interface';
